if (!customElements.get('cart-drawer-recommendations')) {
    class CartDrawerRecommendations extends HTMLElement {
        connectedCallback() {
            if (this.dataset.initialized) return;
            this.dataset.initialized = 'true';

            // Initialize Splide with a small polling mechanism in case splide.min.js loads after this script
            const initSplide = () => {
                if (typeof Splide !== 'undefined') {
                    const splideEl = this.querySelector('.recommendation-splide-container');
                    if (splideEl && !splideEl.classList.contains('is-initialized')) {
                        const splide = new Splide(splideEl, {
                            type: 'loop',
                            perPage: 1,
                            perMove: 1,
                            gap: '1rem',
                            arrows: true,
                            pagination: false
                        });
                        splide.mount();

                        setTimeout(() => {
                            splide.refresh();
                        }, 300);
                    }
                } else {
                    // Check again in 50ms if Splide is not yet loaded
                    setTimeout(initSplide, 50);
                }
            };
            
            initSplide();

            // Ensure Splide is re-mounted if morphdom re-renders this element
            this.observer = new MutationObserver((mutations) => {
                let needsInit = false;
                for (const mutation of mutations) {
                    if (mutation.type === 'attributes' && mutation.attributeName === 'data-initialized') {
                        if (!this.hasAttribute('data-initialized')) {
                            this.dataset.initialized = 'true';
                            needsInit = true;
                        }
                    }
                    if (mutation.type === 'childList') {
                        const splideEl = this.querySelector('.recommendation-splide-container');
                        if (splideEl && !splideEl.classList.contains('is-initialized')) {
                            needsInit = true;
                        }
                    }
                }
                
                if (needsInit) {
                    initSplide();
                }
            });

            this.observer.observe(this, { attributes: true, attributeFilter: ['data-initialized'], childList: true, subtree: true });
        }

        disconnectedCallback() {
            if (this.observer) this.observer.disconnect();
        }
    }
    customElements.define('cart-drawer-recommendations', CartDrawerRecommendations);
}
